<template>
  <article>
    <section class="xbed-sub-title">
      <span>{{title}}</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>广告设计</BreadcrumbItem>
        <BreadcrumbItem>{{title}}</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <section style="margin-top:20px">
      <Form inline>
        <FormItem prop="searchAdName">
          <Input v-model="searchAdName" placeholder="请输入查询广告名称" icon="ios-search" @on-enter="queryWithKeyword" @on-click="queryWithKeyword"></Input>
        </FormItem>

        <FormItem prop="terminal" label="终端位置：" :label-width="100">
          <Select v-model="terminal" style="width:200px;" @on-change='queryWithKeyword'>
            <Option v-bind:value="allTerminalType">不限</Option>
            <Option v-for="adTerminal in adTerminalTypes" v-bind:value="adTerminal.id" :key="adTerminal.id">{{adTerminal.name}}</Option>
          </Select>
        </FormItem>

        <FormItem prop="openModal">
          <Button type="info" @click="openModal('create')">新增</Button>
        </FormItem>
      </Form>

    </section>
    <section>
      <Tabs class="tabs" @on-click="toggleTab" style="margin-top:20px">
        <TabPane v-for="(bundle, i) in bundles" :key="i" :label="bundle.tabName" :name="bundle.name" :ref="bundle.name">
          <Table stripe :loading="bundle.loading" :columns="columns" :data="bundle.data"></Table>
          <div style="float: left;margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="bundle.count" :current="bundle.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
          </div>
        </TabPane>
      </Tabs>
    </section>

    <Modal v-model="modalDisplay" ref="advertModal" :loading="modalLoading" :title="advertForm.title" @on-ok="prepareAddAdvert" @on-cancel="cancelAddAdvert">
      <Form :model="advertForm" ref="advertForm"  :rules="advertFormRules" :label-width="80">

        <FormItem label="广告名称" prop="name" v-if="modalAction==='create'">
          <Input v-model="advertForm.name" placeholder="请输入广告名称"></Input>
        </FormItem>

        <FormItem label="广告名称" prop="name" v-if="modalAction==='update'">
          <Input v-model="advertForm.name" disabled></Input>
        </FormItem>

        <FormItem label="描述" prop="remark">
          <Input v-model="advertForm.remark" placeholder="请输入广告描述内容"></Input>
        </FormItem>

        <FormItem label="广告类型" prop="type">
          <Select v-model="advertForm.type" filterable>
            <Option v-bind:value="1">轮播图</Option>
            <Option v-bind:value="2">广告图</Option>
            <Option v-bind:value="3">招聘图</Option>
            <Option v-bind:value="4">城市图</Option>
            <Option v-bind:value="5">新闻动态</Option>
            <Option v-bind:value="6">精品设计</Option>
            <Option v-bind:value="7">当季热门</Option>
            <Option v-bind:value="8">App启动广告图</Option>
          </Select>
        </FormItem>

        <FormItem label="跳转方式" prop="jumpType">
            <RadioGroup v-model="advertForm.jumpType">
              <Radio v-bind:label='1'>
                <span>链接地址</span>
              </Radio>
              <Radio v-bind:label='2' v-if="advertForm.type == 1 || advertForm.type == 8">
                <span>房间</span>
              </Radio>
              <Radio v-bind:label='3' v-if="advertForm.type == 1 || advertForm.type == 8">
                <span>门店</span>
              </Radio>
              <Radio v-bind:label='0'>
                <span>无</span>
              </Radio>
            </RadioGroup>
        </FormItem>

        <FormItem v-if="advertForm.jumpType!=0" :label="advertForm.jumpType == 1 ? '链接地址' : advertForm.jumpType == 2 ? '房间ID' : '门店ID' " prop="url">
          <Input v-model="advertForm.url" placeholder="请输入链接地址"></Input>
        </FormItem>

        <FormItem label="状态" prop="status">
          <Select v-model="advertForm.status">
            <Option v-bind:value='0'>关闭</Option>
            <Option v-bind:value='1'>开启</Option>
          </Select>
        </FormItem>

        <FormItem label="权重值：" prop="sortNum">
          <InputNumber :max="500" :min="0" v-model="advertForm.sortNum"></InputNumber>
        </FormItem>

        <FormItem label="终端" prop="terminal">
          <CheckboxGroup v-model="advertForm.terminal">
            <Checkbox v-if="advertForm.type!=8" :label="1">
              <span>Xbed 微信</span>
            </Checkbox>
            <Checkbox :label="2">
              <span>Xbed iOS</span>
            </Checkbox>
            <Checkbox :label="3">
              <span>Xbed Android</span>
            </Checkbox>
            <Checkbox v-if="advertForm.type!=8" :label="4">
              <span>蓝主人 微信</span>
            </Checkbox>
            <Checkbox :label="8">
              <span>管家端 Android</span>
            </Checkbox>
            <Checkbox :label="7">
              <span>管家端 iOS</span>
            </Checkbox>
            <Checkbox v-if="advertForm.type!=8" :label="9">
              <span>房东端 微信</span>
            </Checkbox>
            <Checkbox v-if="advertForm.type!=8" :label="10">
              <span>Xbed PC端</span>
            </Checkbox>
            <!-- 2019-09-02新增xms平板终端 1025上生产 -->
            <Checkbox :label="11">
              <span>XMS平板</span>
            </Checkbox>
            <Button :type="isAll?'error':'primary'" size="small" style="margin-left:30px" @click="sellectAll">{{isAll?'反选':'全选'}}</Button>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <hr>
      <img :src="advertForm.picPath" alt="" style="width:100%">
      <Upload action="//upload.qiniup.com" name="file" :format="['jpg','jpeg','png']" :data="uploadData.form" :before-upload="beforeUpload" :on-success="uploadSuccess" :show-upload-list=false>
        <Button type="primary" icon="ios-cloud-upload-outline">上传文件</Button>
      </Upload>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";
import {chRegExp,numRegExp} from "../../utils/regular"
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    // this.queryHomeList()
    // this.queryStoreList()
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.resetBundle();
    this.toggleTab(this.bundles[0].name);
  },
  data() {
    return {
      title: "运营位管理",
      isAll: false,
      // 用 999 代表所有终端..
      terminal: 999,
      allTerminalType: 999,
      advertObj: {},
      adTerminalTypes: [
        {
          name: '所有终端',
          id: 0
        },
        {
          name: 'Xbed Android',
          id: 3
        },
        {
          name: 'Xbed iOS',
          id: 2
        },
        {
          name: 'Xbed 微信',
          id: 1
        },
        {
          name: 'Xbed PC端',
          id: 10
        },
        {
          name: '管家端 Android',
          id: 8
        },
        {
          name: '管家端 iOS',
          id: 7
        },
        {
          name: '房东端 微信',
          id: 9
        },
        {
          name: '蓝主人 微信',
          id: 4
        },
        // 2019-09-02新增xms平板终端
        {
          name: 'XMS平板',
          id: 11
        },
      ],
      currBundleName: "loop",
      columns: [
        {
          title: "广告id",
          key: "advertId",
          align: "center",
          width: 100
        },
        {
          title: "广告名称",
          key: "name",
          align: "center",
          width: 200
        },
        {
          title: "描述",
          key: "remark",
          width: 200,
          align: "center"
        },
        {
          title: "图片地址",
          key: "picPath",
          width: 300,
          align: "center"
        },
        {
          title: "链接地址",
          key: "url",
          width: 300,
          align: "center"
        },
        {
          title: "终端",
          key: "terminal",
          width: 200,
          align: "center",
          render: (h, params) => {
            const list = params.row.listTerminal;
            let listTag = [];
            list.forEach(item => {
              listTag.push(h('Tag', {
                props: {
                  color: 'yellow'
                }
              }, item.terminalName))
            });
            return h("div", {}, listTag);
          }
        },
        {
          title: "权重值",
          key: "sortNum",
          width: 200,
          align: "center"
        },
        {
          title: "状态",
          key: "status",
          width: 200,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const color = row.status === 1 ? "green" : "red";
            const text = row.status === 1 ? "开启" : "关闭";

            return h(
              "Tag",
              {
                props: {
                  type: "dot",
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: "操作",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.updateAdvert(params.index);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        render: modalH => {
                          let modalText = `确定删除 ${params.row
                            .advertId} - ${params.row.name} 吗？\n一经确定将无法修改`;
                          return modalH(
                            "div",
                            {
                              style: {
                                fontSize: "16px"
                              }
                            },
                            modalText
                          );
                        },
                        onOk: () => {
                          this.delAdvert(params.index);
                        }
                      });
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      bundles: [],
      modalDisplay: false,
      modalLoading: true,
      modalAction: "",
      searchAdName: "", // 模糊查询广告名称
      // 新增 修改Modal
      advertForm: {
        name: "",
        remark: "",
        sortNum: 1,
        jumpType: 0,
        type: 1,
        url: "",
        status: 0,
        terminal: [],
        picPath: "",
        materialId: ""
      },
      uploadData: {
        name: "",
        form: {}
      },
      // 新增广告校验
      advertFormRules: {
        name: [
          { required: true, message: "广告名称不能为空", trigger: "blur" },
          { type: "string", max: 50, message: "广告名称不能超过50字" }
        ],
        remark: [
          { required: true, message: "广告描述不能为空", trigger: "blur" },
          { type: "string", max: 200, message: "广告描述不能超过200字" }
        ],
        sortNum: [
          { required: true, type:'number', message: "权重值不能为空", trigger: "blur" },
        ],
        terminal: [
          { required: true, type:'array', message: "请选择终端", trigger: "blur" },
        ]
      }
    };
  },
  watch:{
    'advertForm.type':function(val){
      // this.advertForm.terminal = val == 7 ? 7 : 0
      if(val) {
        this.advertForm.terminal = [];
        this.isAll = false;
        if(this.advertForm.type !== 1){
          this.advertForm.jumpType = 0
        }
      }
    },
    'advertForm.jumpType': function (val) {
      if(val && val !==0 ) {
        if(val === this.advertObj.jumpType){
          this.advertForm.url = this.advertObj.url || "";
        }else{
          this.advertForm.url = ""
        }
      }
    }
  },
  methods: {
    toggleTab(tabName) {
      this.currBundleName = tabName;
      this.searchAdName = "";
      let curr = this.getCurrBundleIndex();
      this.bundles[curr].page = 1;
      this.query(this.bundles[curr]);
    },
    sellectAll() {
      if(this.advertForm.type==8) {
        if(this.advertForm.terminal.length===4){
          this.advertForm.terminal = []
          this.isAll = false
        }else{
          this.advertForm.terminal = [2,3,7,8]
          this.isAll = true
        }
      }else {
        if(this.advertForm.terminal.length===8){
          this.advertForm.terminal = []
          this.isAll = false
        }else{
          this.advertForm.terminal = [1,2,3,4,7,8,9,10,11]
          this.isAll = true
        }
      }
    },
    // 获取当前tab的内容
    getCurrBundleIndex() {
      for (let i = 0; i < this.bundles.length; i++) {
        if (this.bundles[i].name === this.currBundleName) {
          return i;
        }
      }
    },
    changePage(pageIndex) {
      let curr = this.getCurrBundleIndex();
      this.bundles[curr].page = pageIndex;
      this.query(this.bundles[curr]);
    },
    changePageSize(pageSize) {
      let curr = this.getCurrBundleIndex();
      this.bundles[curr].page = 1;
      this.bundles[curr].pageSize = pageSize;
      this.query(this.bundles[curr]);
    },
    queryWithKeyword() {
      let curr = this.getCurrBundleIndex();
      this.bundles[curr].page = 1;
      this.query(this.bundles[curr]);
    },
    async query(bundle) {
      bundle.loading = true;
      (bundle.type == 0) && (bundle.type = 7)
      const resp = (await this.queryAdvertList(
        bundle,
        this.searchAdName,
        this.terminal,
        this.token,
        this.env
      )).data;
      bundle.data = resp.result;
      bundle.page = resp.page;
      bundle.pageSize = resp.pageSize;
      bundle.pageCount = resp.pageCount;
      bundle.count = resp.count;
      bundle.loading = false;
    },
    queryAdvertList(bundle, searchName, terminal, token, env) {
      return API.omsAPI[env].advert.queryAdvertList(
        bundle.page,
        bundle.pageSize,
        bundle.type,
        searchName,
        terminal === this.allTerminalType ? null : terminal,
        token
      );
    },
    updateAdvert(index) {
      let curr = this.getCurrBundleIndex();
      let advert = this.bundles[curr].data[index];
      this.advertObj = this.bundles[curr].data[index];
      if(advert.jumpType == 1){
        this.advertForm.url = advert.url;
      }else if(advert.jumpType == 2){
        this.advertForm.homeId = Number(advert.url);
      }else if(advert.jumpType == 3){
        this.advertForm.storeId = advert.url;
      }
      this.advertForm.advertId = advert.advertId;
      this.advertForm.name = advert.name;
      this.advertForm.remark = advert.remark;
      this.advertForm.type = advert.type;
      this.advertForm.status = advert.status;
      this.advertForm.terminal = [];
      this.advertForm.sortNum = advert.sortNum;
      this.advertForm.picPath = advert.picPath;
      this.advertForm.materialId = advert.materialId;
      this.openModal("update");
      this.$nextTick(() => {
        advert.listTerminal.forEach(item => {
          this.advertForm.terminal.push(item.terminalId)
        }),
        this.advertForm.jumpType = advert.jumpType == '' ? 0 : advert.jumpType;
      })
    },
    openModal(action) {
      this.modalDisplay = true;
      this.modalAction = action;
      if (action === "create") {
        this.advertForm.title = "新建广告";
        this.advertForm.type = 1;
        this.advertForm.status = 0;
        this.advertObj = {};
      } else if (action === "update") {
        this.advertForm.title = "修改广告";
      }
    },
    resetAddModalData() {
      this.$refs.advertForm.resetFields()
      this.advertForm = {
        name: "",
        remark: "",
        jumpType: 0,
        type: "1",
        url: "",
        status: "1",
        sortNum: 1,
        terminal: "0",
        picPath: "",
        materialId: ""
      };
      this.uploadData = {
        name: "",
        form: {}
      };
    },
    // 添加广告
    prepareAddAdvert() {  
      this.$refs.advertForm.validate(valid => {
        if (valid) {
          this.addAdvert();
        } else {
          this.$refs.advertModal.buttonLoading = false;
        }
      })
    },
    async addAdvert() {
      
      this.$refs.advertModal.buttonLoading = false;
      if (chRegExp.test(this.advertForm.url)) {
          this.$Notice.error({
            title: "不能为中文"
          });    
          this.$refs.advertModal.buttonLoading = false;
          return;      
      }
      if(this.advertForm.jumpType != 0 && this.advertForm.url == '') {
        this.$Notice.error({
          title: '跳转链接不能为空'
        })
        return
      }
      if (this.advertForm.jumpType == 2 || this.advertForm.jumpType == 3){
        if (!numRegExp.test(this.advertForm.url)) {
          this.$Notice.error({
            title: `${this.advertForm.jumpType == 2 ? '房间' : '门店'}ID只能为正整数`
          }); 
          // 重置确定按钮
          this.$refs.advertModal.buttonLoading = false;
          return;            
        }
      }
      if(this.advertForm.terminal.length===0) {
        this.$Notice.error({
          title: '投放终端不能为空'
        })
        return
      }
      if (this.modalAction === "create") {
        if (Object.keys(this.uploadData.form).length == 0) {
          // 错误警告
          this.$Notice.error({
            title: "图片不能为空"
          });
          // 重置确定按钮
          this.$refs.advertModal.buttonLoading = false;
          return;
        }
        this.advertForm.createName = this.username;
        let params = {}
        Object.keys(this.advertForm).forEach(key => {
          this.advertForm[key] !== '' && (params[key] = this.advertForm[key])
        })
        params.listTerminalId = JSON.stringify(params.terminal)
        delete params.terminal
        delete params.title
        !params.url && (params.url = '')
        let resp = (await API.omsAPI[this.env].advert.addAdvert(
          params,
          this.token
        )).data;

        if (resp.retCode) {
          // 错误警告
          this.$refs.advertModal.buttonLoading = false;
          this.$Notice.error({
            title: "添加广告失败",
            desc: resp.msg
          });
        } else {
          this.$Notice.success({
            title: "添加广告成功"
          });
          this.modalDisplay = false;
          this.refreshTable();
          this.resetAddModalData();
        }
      } else if (this.modalAction === "update") {
        this.advertForm.updateName = this.username;
        let params = {}
        Object.keys(this.advertForm).forEach(key => {
          this.advertForm[key] !== '' && (params[key] = this.advertForm[key])
        })
        params.listTerminalId = JSON.stringify(params.terminal)
        delete params.terminal
        delete params.title
        !params.url && (params.url = '')
        let resp = (await API.omsAPI[this.env].advert.editAdvert(
          params,
          this.token
        )).data;

        if (resp.retCode) {
          // 错误警告
          this.$Notice.error({
            title: "修改广告失败",
            desc: resp.msg
          });
        } else {
          this.$Notice.success({
            title: "修改广告成功"
          });
          this.refreshTable();
        }
        this.modalDisplay = false;
        this.resetAddModalData();
      }
    },
    // 取消添加广告
    cancelAddAdvert() {
      this.resetAddModalData();
    },
    // 删除广告
    async delAdvert(index) {
      let curr = this.getCurrBundleIndex();
      let advert = this.bundles[curr].data[index];

      let resp = (await API.omsAPI[this.env].advert.deleteAdvert(
        advert.advertId,
        this.username,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除广告失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除广告成功"
        });

        this.bundles[curr].data.splice(index, 1);
      }
    },
    resetBundle() {
      this.bundles = [
        {
          name: 'app',
          tabName: 'App启动广告图',
          type: 8,
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: []
        },
        {
          name: "loop",
          tabName: "轮播图",
          type: 1,
          count: 0, //记录总数
          pageCount: 0, //页面总数
          page: 1, // 第几页
          pageSize: 10, // 每页数量
          loading: false,
          data: []
        },
        {
          name: "ad",
          tabName: "广告图",
          type: 2,
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: []
        },
        {
          name: "jd",
          tabName: "招聘图",
          type: 3,
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: []
        },
        {
          name: "city",
          tabName: "热门城市图",
          type: 4,
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: []
        },
        {
          name: "news",
          tabName: "新闻动态",
          type: 5,
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: []
        },
        {
          name: "design",
          tabName: "精品设计",
          type: 6,
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: []
        },
        {
          name: "hot",
          tabName: "当季热门",
          type: 7,
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: []
        }
      ];
    },
    refreshTable() {
      this.resetBundle();
      this.searchAdName = "";
      let curr = this.getCurrBundleIndex();
      this.bundles[curr].page = 1;
      this.query(this.bundles[curr]);
    },
    // 图片上传前
    async beforeUpload(file) {
      console.info(`${file}`);
      let token = (await API.omsAPI[this.env].common.getUploadToken(
        false,
        this.token
      )).data;
      this.uploadData.form.token = token;

      // this.advertForm.uploadData.token = token
      this.uploadData.name = `${(Date.now() / 1000) | 0}_${file.name}`;
      this.uploadData.form["x:fileDirId"] = 636;
      this.uploadData.form["x:isPrivate"] = 0;
      this.uploadData.form["x:remark"] = "新增广告图";
      return true;
    },
    uploadSuccess(resp) {
      this.advertForm.picPath = resp.materialBase.url;
      this.advertForm.materialId = resp.materialBase.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/advert/list.vue